// import Sidebar from "pages/sideBar/SideBar";
// import React, { useEffect, useMemo, useState } from "react";
// import "../app.css";
// import "./SellarShop.css";
// import PopupSellar from "./popupsellar";
// import axios from "axios";
// import { ToastContainer, toast } from "react-toastify";
// import { Box, Skeleton } from "@mui/material";
// import { FiEdit2 } from "react-icons/fi";
// import { MdDeleteOutline } from "react-icons/md";

// const API_BASE_URL = "https://backend.washta.com";

// /* ─────────────────────────────────────────────
//    Constants
// ───────────────────────────────────────────── */
// const CAR_TYPE_OPTIONS = ["Sedan", "SUV", "Van", "Motorcycle", "Truck"];
// const VEHICLE_TYPES = {
//   Sedan: "sedan",
//   SUV: "suv",
//   Van: "van",
//   Motorcycle: "motorcycle",
//   Truck: "truck",
// };

// const buildCarPricingFromTypes = (types = [], existingPricing = []) => {
//   const normalizedTypes = Array.isArray(types)
//     ? types.map((type) => String(type).trim()).filter(Boolean)
//     : [];
//   return normalizedTypes.map((type) => {
//     const existing = (
//       Array.isArray(existingPricing) ? existingPricing : []
//     ).find((item) => item?.carName === type);
//     return {
//       carName: type,
//       vehicleType:
//         VEHICLE_TYPES[type] || type.toLowerCase().replace(/\s+/g, "_"),
//       price: existing?.price ?? "",
//     };
//   });
// };

// /* ─────────────────────────────────────────────
//    Helper: Create blank service
// ───────────────────────────────────────────── */
// const createBlankService = () => ({
//   serviceName: "",
//   catalogId: "",
//   category: "exterior",
//   heroImageUrl: "",
//   supportedCarTypes: ["Sedan", "SUV"],
//   customCarTypes: [],
//   variants: [
//     {
//       variantName: "",
//       variantType: "stationed",
//       badgeText: "",
//       parkingPrompt: "",
//       estimatedTime: 30,
//       estimatedTimeUnit: "minutes",
//       samePriceForAllCars: false,
//       basePrice: "",
//       carPricing: [
//         { carName: "Sedan", vehicleType: "sedan", price: "" },
//         { carName: "SUV", vehicleType: "suv", price: "" },
//       ],
//       addOns: [{ name: "", price: "", isActive: true }],
//       isActive: true,
//     },
//   ],
//   isActive: true,
// });

// const getInitials = (value) => {
//   const text = typeof value === "string" ? value.trim() : "";
//   if (!text) return "?";

//   const parts = text.split(/\s+/).filter(Boolean);
//   const initials = parts
//     .slice(0, 2)
//     .map((part) => part[0])
//     .join("")
//     .toUpperCase();

//   return initials || text.slice(0, 2).toUpperCase();
// };

// /* ─────────────────────────────────────────────
//    Confirm Modal
// ───────────────────────────────────────────── */
// const ConfirmModal = ({ isOpen, title, message, onConfirm, onCancel }) => {
//   if (!isOpen) return null;
//   return (
//     <div className="ss-modal-overlay" onClick={onCancel}>
//       <div className="ss-modal-box" onClick={(e) => e.stopPropagation()}>
//         <div className="ss-modal-title">{title}</div>
//         <div className="ss-modal-message">{message}</div>
//         <div className="ss-modal-actions">
//           <button className="ss-modal-btn-cancel" onClick={onCancel}>
//             Cancel
//           </button>
//           <button className="ss-modal-btn-confirm" onClick={onConfirm}>
//             Yes, Delete
//           </button>
//         </div>
//       </div>
//     </div>
//   );
// };

// const Toggle = ({ checked, onChange }) => (
//   <button
//     type="button"
//     role="switch"
//     aria-checked={checked}
//     className={`ss-mini-toggle ${checked ? "on" : ""}`}
//     onClick={() => onChange(!checked)}
//   >
//     <span className="ss-toggle-knob"></span>
//   </button>
// );
// const CarTypeChips = ({
//   selected,
//   customTypes = [],
//   onChange,
//   onCustomTypesChange,
// }) => {
//   const [showCustomInput, setShowCustomInput] = useState(false);
//   const [customValue, setCustomValue] = useState("");
//   const allTypes = [
//     ...CAR_TYPE_OPTIONS,
//     ...customTypes.filter((type) => !CAR_TYPE_OPTIONS.includes(type)),
//   ];

//   const toggle = (type) => {
//     const next = selected.includes(type)
//       ? selected.filter((t) => t !== type)
//       : [...selected, type];
//     onChange(next);
//   };

//   const handleAddCustom = () => {
//     const value = customValue.trim();
//     if (!value) return;

//     const existingCustomTypes = Array.isArray(customTypes) ? customTypes : [];
//     const alreadyExists = [...CAR_TYPE_OPTIONS, ...existingCustomTypes].some(
//       (item) => item.toLowerCase() === value.toLowerCase(),
//     );

//     const nextCustomTypes = alreadyExists
//       ? existingCustomTypes
//       : [...existingCustomTypes, value];

//     const alreadySelected = selected.some(
//       (item) => item.toLowerCase() === value.toLowerCase(),
//     );
//     const nextSelected = alreadySelected ? selected : [...selected, value];

//     onCustomTypesChange(nextCustomTypes, nextSelected);

//     setCustomValue("");
//     setShowCustomInput(false);
//   };

//   return (
//     <div>
//       <div className="ss-car-types-row">
//         {allTypes.map((type) => {
//           const on = selected.includes(type);
//           return (
//             <button
//               key={type}
//               type="button"
//               className={`ss-car-chip ${on ? "on" : ""}`}
//               onClick={() => toggle(type)}
//             >
//               <div className="ss-checkbox">{on ? "✓" : ""}</div>
//               {type}
//             </button>
//           );
//         })}
//         <button
//           type="button"
//           className="ss-car-chip custom"
//           onClick={() => setShowCustomInput((prev) => !prev)}
//         >
//           + Custom
//         </button>
//       </div>
//       {showCustomInput && (
//         <div className="ss-custom-car-row">
//           <input
//             className="ss-custom-car-input"
//             placeholder="Custom car type"
//             value={customValue}
//             onChange={(e) => setCustomValue(e.target.value)}
//             onKeyDown={(e) => {
//               if (e.key === "Enter") {
//                 e.preventDefault();
//                 handleAddCustom();
//               }
//             }}
//           />
//           <button type="button" className="ss-btn-sm" onClick={handleAddCustom}>
//             Add
//           </button>
//         </div>
//       )}
//     </div>
//   );
// };

// /* ─────────────────────────────────────────────
//    Sub-components: Variant Editor
// ───────────────────────────────────────────── */
// const VariantEditor = ({ variant, index, onUpdate, onRemove }) => {
//   const handleUpdate = (field, value) => {
//     onUpdate(index, { ...variant, [field]: value });
//   };

//   const handleCarPricingUpdate = (priceIndex, field, value) => {
//     const updated = variant.carPricing.map((item, i) =>
//       i === priceIndex ? { ...item, [field]: value } : item,
//     );
//     handleUpdate("carPricing", updated);
//   };

//   const handleAddOnUpdate = (addonIndex, field, value) => {
//     const updated = variant.addOns.map((item, i) =>
//       i === addonIndex ? { ...item, [field]: value } : item,
//     );
//     handleUpdate("addOns", updated);
//   };

//   const handleAddOnAdd = () => {
//     const nextAddons = [
//       ...(Array.isArray(variant.addOns) ? variant.addOns : []),
//       { name: "", price: "", isActive: true },
//     ];
//     handleUpdate("addOns", nextAddons);
//   };

//   const handleAddCarPricingRow = () => {
//     const nextRows = [
//       ...(Array.isArray(variant.carPricing) ? variant.carPricing : []),
//       { carName: "", vehicleType: "custom", price: "" },
//     ];
//     handleUpdate("carPricing", nextRows);
//   };

//   const handleRemoveCarPricingRow = (rowIndex) => {
//     const currentRows = Array.isArray(variant.carPricing)
//       ? variant.carPricing
//       : [];
//     if (currentRows.length <= 1) {
//       toast.error("At least one car price row is required");
//       return;
//     }
//     handleUpdate(
//       "carPricing",
//       currentRows.filter((_, i) => i !== rowIndex),
//     );
//   };

//   const handleCarNameChange = (priceIndex, value) => {
//     const nextVehicleType = value.trim().toLowerCase().replace(/\s+/g, "_");
//     const updated = variant.carPricing.map((item, i) =>
//       i === priceIndex
//         ? { ...item, carName: value, vehicleType: nextVehicleType || "custom" }
//         : item,
//     );
//     handleUpdate("carPricing", updated);
//   };

//   return (
//     <div className="ss-variant-card">
//       <div className="ss-variant-head">
//         <div className="ss-field-label">Variant name (shown on app)</div>
//         <select
//           className="ss-variant-type-select"
//           value={variant.variantType}
//           onChange={(e) => handleUpdate("variantType", e.target.value)}
//         >
//           <option value="stationed">Stationed — customer parks</option>
//           <option value="mobile">Mobile — we go to customer</option>
//         </select>
//         {index > 0 && (
//           <span className="ss-variant-remove" onClick={() => onRemove(index)}>
//             ✕ Remove
//           </span>
//         )}
//       </div>
//       <div className="ss-variant-body">
//         <div>
//           <input
//             className="ss-edit-input"
//             value={variant.variantName}
//             onChange={(e) => handleUpdate("variantName", e.target.value)}
//             placeholder="e.g. Exterior only"
//           />
//         </div>
//         <div>
//           <div className="ss-field-label">Badge text (shown on app)</div>
//           <div className="ss-badge-row">
//             {variant.badgeText && (
//               <span className="ss-badge-pill">{variant.badgeText}</span>
//             )}
//             <input
//               className="ss-edit-input"
//               style={{ flex: 1 }}
//               value={variant.badgeText}
//               onChange={(e) => handleUpdate("badgeText", e.target.value)}
//               placeholder={
//     variant.variantType === "stationed"
//       ? "e.g. Park At Station"
//       : "e.g. We come to you"
//   }
//             />
//           </div>
//         </div>
//         {variant.variantType === "stationed" && (
//           <div>
//             <div className="ss-field-label">Parking prompt (customer sees this)</div>
//             <input
//               className="ss-edit-input"
//               value={variant.parkingPrompt}
//               onChange={(e) => handleUpdate("parkingPrompt", e.target.value)}
//               placeholder="Tell the customer where to park or meet you"
//             />
//           </div>
//         )}
//         <div>
//           <div className="ss-field-label">Estimated Time</div>
//           <div style={{ display: "flex", gap: "10px", alignItems: "flex-end" }}>
//             <div style={{ flex: 1 }}>
//               <input
//                 className="ss-edit-input"
//                 type="number"
//                 min="1"
//                 value={variant.estimatedTime || ""}
//                 onChange={(e) => handleUpdate("estimatedTime", Number(e.target.value))}
//                 placeholder="e.g. 45"
//                 style={{border:'1px solid #ddd',padding:'6px 10px',borderRadius:'7px'}}
//               />
//             </div>
//             <select
//               className="ss-edit-input"
//               value={variant.estimatedTimeUnit || "minutes"}
//               onChange={(e) => handleUpdate("estimatedTimeUnit", e.target.value)}
//               style={{ flex: 0, minWidth: "120px", marginBottom: "0" }}
//             >
//               <option value="minutes">Minutes</option>
//               <option value="hours">Hours</option>
//             </select>
//           </div>
//         </div>
//         <div>
//           <div className="ss-field-label">Pricing</div>
//           <div className="ss-same-price-row">
//             <Toggle
//               checked={variant.samePriceForAllCars}
//               onChange={(val) => handleUpdate("samePriceForAllCars", val)}
//             />
//             <span className="ss-toggle-label">
//               Same price for all car types
//             </span>
//           </div>
//           <div className="ss-price-matrix">
//             {variant.samePriceForAllCars ? (
//               <div className="ss-price-row">
//                 <span className="ss-price-car">All car types</span>
//                 <div className="ss-price-wrap">
//                   <span className="ss-price-cur">AED</span>
//                   <input
//                     className="ss-price-input"
//                     type="number"
//                     min="0"
//                     value={variant.basePrice}
//                     onChange={(e) => handleUpdate("basePrice", e.target.value)}
//                   />
//                 </div>
//               </div>
//             ) : (
//               variant.carPricing.map((car, i) => (
//                 <div key={i} className="ss-price-row">
//                   <input
//                     className="ss-price-car-input"
//                     value={car.carName}
//                     onChange={(e) => handleCarNameChange(i, e.target.value)}
//                     placeholder="Car type"
//                   />
//                   <div className="ss-price-wrap">
//                     <span className="ss-price-cur">AED</span>
//                     <input
//                       className="ss-price-input"
//                       type="number"
//                       min="0"
//                       value={car.price}
//                       onChange={(e) =>
//                         handleCarPricingUpdate(i, "price", e.target.value)
//                       }
//                     />
//                   </div>
//                   <span
//                     className="ss-addon-remove"
//                     onClick={() => handleRemoveCarPricingRow(i)}
//                   >
//                     ✕
//                   </span>
//                 </div>
//               ))
//             )}
//           </div>
//           {/* {!variant.samePriceForAllCars && (
//             <button
//               type="button"
//               className="ss-btn-sm ss-compact-btn"
//               onClick={handleAddCarPricingRow}
//             >
//               + Add car type
//             </button>
//           )} */}
//         </div>
//         <div className="ss-addons-block">
//           <div className="ss-addons-header">
//             <div className="ss-addons-title">Add-ons for this variant</div>
//             <span className="ss-addons-add" onClick={handleAddOnAdd}>
//               + Add
//             </span>
//           </div>
//           {(Array.isArray(variant.addOns) ? variant.addOns : []).map(
//             (addon, i) => (
//               <div key={i} className="ss-addon-item">
//                 <input
//                   className="ss-addon-name-input"
//                   value={addon.name}
//                   onChange={(e) => handleAddOnUpdate(i, "name", e.target.value)}
//                   placeholder="Air freshener"
//                 />
//                 <div className="ss-addon-price-wrap">
//                   <span className="ss-addon-price-cur">AED</span>
//                   <input
//                     className="ss-addon-price-input"
//                     type="number"
//                     min="0"
//                     value={addon.price}
//                     onChange={(e) =>
//                       handleAddOnUpdate(i, "price", e.target.value)
//                     }
//                   />
//                 </div>
//                 <Toggle
//                   checked={addon.isActive}
//                   onChange={(val) => handleAddOnUpdate(i, "isActive", val)}
//                 />
//                 <span
//                   className="ss-addon-remove"
//                   onClick={() => {
//                     const updated = variant.addOns.filter(
//                       (_, idx) => idx !== i,
//                     );
//                     handleUpdate("addOns", updated);
//                   }}
//                 >
//                   ✕
//                 </span>
//               </div>
//             ),
//           )}
//         </div>
//       </div>
//     </div>
//   );
// };

// /* ─────────────────────────────────────────────
//    Sub-components: Service Editor (inline)
// ───────────────────────────────────────────── */
// const ServiceEditor = ({ service, onSave, onRemove, isNew, catalogOptions = [] }) => {
//   const [draft, setDraft] = useState(service);
//   const [isImageUploading, setIsImageUploading] = useState(false);
//   const imageInputRef = React.useRef(null);

//   const handleUpdate = (field, value) => setDraft({ ...draft, [field]: value });

//   const handleVariantUpdate = (index, variant) => {
//     const updated = draft.variants.map((v, i) => (i === index ? variant : v));
//     setDraft({ ...draft, variants: updated });
//   };

//   // const applySupportedTypesToVariants = (
//   //   nextSupportedTypes,
//   //   nextCustomTypes = draft.customCarTypes || [],
//   // ) => {
//   //   const resolvedTypes = Array.from(
//   //     new Set([...(nextSupportedTypes || []), ...(nextCustomTypes || [])]),
//   //   );
//   //   const updatedVariants = (
//   //     Array.isArray(draft.variants) ? draft.variants : []
//   //   ).map((variant) => {
//   //     if (variant.samePriceForAllCars) return variant;
//   //     return {
//   //       ...variant,
//   //       carPricing: buildCarPricingFromTypes(resolvedTypes, variant.carPricing),
//   //     };
//   //   });
//   //   setDraft((prev) => ({
//   //     ...prev,
//   //     supportedCarTypes: nextSupportedTypes,
//   //     customCarTypes: nextCustomTypes,
//   //     variants: updatedVariants,
//   //   }));
//   // };
// const applySupportedTypesToVariants = (
//   nextSupportedTypes,
//   nextCustomTypes = draft.customCarTypes || [],
// ) => {
//   const resolvedTypes = Array.from(new Set(nextSupportedTypes || []));

//   const updatedVariants = (
//     Array.isArray(draft.variants) ? draft.variants : []
//   ).map((variant) => {
//     if (variant.samePriceForAllCars) return variant;
//     return {
//       ...variant,
//       carPricing: buildCarPricingFromTypes(resolvedTypes, variant.carPricing),
//     };
//   });
//   setDraft((prev) => ({
//     ...prev,
//     supportedCarTypes: nextSupportedTypes,
//     customCarTypes: nextCustomTypes,
//     variants: updatedVariants,
//   }));
// };
//   const handleVariantRemove = (index) => {
//     if (draft.variants.length > 1) {
//       setDraft({
//         ...draft,
//         variants: draft.variants.filter((_, i) => i !== index),
//       });
//     } else {
//       toast.error("Service must have at least one variant");
//     }
//   };

//   const handleAddVariant = () => {
//     const availableTypes = Array.from(
//       new Set([
//         ...(Array.isArray(draft.supportedCarTypes)
//           ? draft.supportedCarTypes
//           : []),
//         ...(Array.isArray(draft.customCarTypes) ? draft.customCarTypes : []),
//       ]),
//     );
//     const newVariant = {
//       variantName: "",
//       variantType: "stationed",
//       badgeText: "",
//       parkingPrompt: "",
//       samePriceForAllCars: false,
//       basePrice: "",
//       carPricing: buildCarPricingFromTypes(
//         availableTypes.length > 0 ? availableTypes : ["Sedan", "SUV"],
//       ),
//       addOns: [],
//       isActive: true,
//     };
//     setDraft({ ...draft, variants: [...draft.variants, newVariant] });
//   };

//   const triggerImageInput = () => {
//     if (imageInputRef.current) imageInputRef.current.click();
//   };

//   const handleServiceImageUpload = async (event) => {
//     const file = event.target.files?.[0];
//     if (!file) return;
//     if (file.size > 5 * 1024 * 1024) {
//       toast.error("Image size must be less than 5MB");
//       return;
//     }
//     const token = localStorage.getItem("accessToken");
//     const uploadFormData = new FormData();
//     uploadFormData.append("file", file);
//     setIsImageUploading(true);
//     try {
//       const uploadResponse = await axios.post(
//         `${API_BASE_URL}/api/uploadFile`,
//         uploadFormData,
//         {
//           headers: {
//             "Content-Type": "multipart/form-data",
//             Authorization: `Bearer ${token}`,
//           },
//         },
//       );
//       const uploadedImageUrl = uploadResponse?.data?.data?.path;
//       if (!uploadedImageUrl) {
//         toast.error("Image upload failed");
//         return;
//       }
//       setDraft((prev) => ({ ...prev, heroImageUrl: uploadedImageUrl }));
//       toast.success("Service image uploaded");
//     } catch (error) {
//       toast.error(
//         error?.response?.data?.error ||
//           error?.response?.data?.message ||
//           "Image upload failed",
//       );
//     } finally {
//       setIsImageUploading(false);
//       event.target.value = "";
//     }
//   };

//   const handleSave = async () => {
//     if (!draft.serviceName.trim()) {
//       toast.error("Service name is required");
//       return;
//     }
//     if (draft.variants.some((v) => !v.variantName.trim())) {
//       toast.error("All variants must have a name");
//       return;
//     }
//     const normalized = {
//       ...draft,
//       variants: (Array.isArray(draft.variants) ? draft.variants : []).map((v) => {
//         if (v.variantType !== "stationed") {
//           const { parkingPrompt, ...rest } = v;
//           return rest;
//         }
//         return v;
//       }),
//     };
//     onSave(normalized);
//   };

//   return (
//     <div className="ss-service-card">
//       <div className="ss-svc-header">
//         <div className="ss-svc-name-block">
//           <div className="ss-field-label">Service name (shown on app)</div>
//           <select
//             className="ss-edit-input"
//             value={draft.catalogId || draft.serviceName || ""}
//             onChange={(e) => {
//               const value = e.target.value;
//               const selectedCatalog = catalogOptions.find(
//                 (item) => String(item.slug || item._id || item.name) === String(value),
//               );
//               setDraft((prev) => ({
//                 ...prev,
//                 catalogId: value,
//                 serviceName: selectedCatalog?.name || prev.serviceName,
//                 heroImageUrl: selectedCatalog?.default_image_url || prev.heroImageUrl,
//               }));
//             }}
//           >
//             <option value="">Select service type</option>
//             {catalogOptions.map((item) => (
//               <option key={item._id || item.slug || item.name} value={String(item.slug || item._id || item.name)}>
//                 {item.name}
//               </option>
//             ))}
//           </select>
//           {/* <input
//             className="ss-edit-input ss-bold"
//             value={draft.serviceName}
//             onChange={(e) => handleUpdate("serviceName", e.target.value)}
//             placeholder="Carwash"
//           /> */}
//         </div>
//         <div className="ss-svc-actions">
//           <span className="ss-action-link">↕ Reorder</span>
//           {!isNew && (
//             <span
//               className="ss-action-link ss-danger"
//               onClick={() => onRemove(draft)}
//             >
//               Remove
//             </span>
//           )}
//         </div>
//       </div>
//       <div className="ss-svc-body">
//         <div className="ss-svc-top-row">
//           {/* <div className="ss-svc-image-col">
//             <div className="ss-field-label">
//               Service card image (home screen)
//             </div>
//             <input
//               ref={imageInputRef}
//               type="file"
//               accept=".png,.jpg,.jpeg"
//               style={{ display: "none" }}
//               onChange={handleServiceImageUpload}
//             />
//             {draft.heroImageUrl ? (
//               <div className="ss-upload-preview" onClick={triggerImageInput}>
//                 <img
//                   src={draft.heroImageUrl}
//                   alt={draft.serviceName}
//                   style={{ width: "100%", height: "100%", objectFit: "cover" }}
//                 />
//                 <div className="ss-upload-preview-overlay">
//                   {isImageUploading ? "Uploading..." : "Change image"}
//                 </div>
//               </div>
//             ) : (
//               <div className="ss-image-upload-zone" onClick={triggerImageInput}>
//                 <div className="ss-upload-icon">🖼️</div>
//                 <div className="ss-upload-title">
//                   {isImageUploading ? "Uploading..." : "Upload service image"}
//                 </div>
//                 <div className="ss-upload-spec">
//                   800×400px · Max 5MB · JPG or PNG
//                 </div>
//               </div>
//             )}
//             <div className="ss-upload-actions">
//               <button
//                 type="button"
//                 className="ss-upload-btn-sm"
//                 onClick={triggerImageInput}
//               >
//                 Change
//               </button>
//               <button
//                 type="button"
//                 className="ss-upload-btn-sm ss-danger"
//                 onClick={() =>
//                   setDraft((prev) => ({ ...prev, heroImageUrl: "" }))
//                 }
//               >
//                 Remove
//               </button>
//             </div>
//             <div style={{ fontSize: "9px", color: "#aaa", marginTop: "5px" }}>
//               800×400px · Max 5MB · JPG or PNG
//             </div>
//           </div> */}
//           <div className="ss-svc-details-col">
//             <div>
//               <div className="ss-field-label">Car types supported</div>
//               <CarTypeChips
//                 selected={draft.supportedCarTypes}
//                 customTypes={draft.customCarTypes || []}
//                 onChange={(nextSelected) => {
//                   applySupportedTypesToVariants(
//                     nextSelected,
//                     draft.customCarTypes || [],
//                   );
//                 }}
//                 // ✅ nextSelected bhi saath aa raha hai — dono ek hi call mein sync
//                 onCustomTypesChange={(nextCustomTypes, nextSelected) => {
//                   const normalizedCustom = Array.from(
//                     new Set(
//                       nextCustomTypes
//                         .map((item) => item.trim())
//                         .filter(Boolean),
//                     ),
//                   );
//                   const resolvedSelected =
//                     nextSelected ||
//                     Array.from(
//                       new Set([
//                         ...(draft.supportedCarTypes || []),
//                         ...normalizedCustom,
//                       ]),
//                     );
//                   applySupportedTypesToVariants(
//                     resolvedSelected,
//                     normalizedCustom,
//                   );
//                 }}
//               />
//             </div>
//           </div>
//         </div>
//         <div className="ss-divider"></div>
//         <div>
//           <div className="ss-field-label">Service variants</div>
//           <div className="ss-variants-col">
//             {draft.variants.map((variant, i) => (
//               <VariantEditor
//                 key={i}
//                 variant={variant}
//                 index={i}
//                 onUpdate={handleVariantUpdate}
//                 onRemove={handleVariantRemove}
//               />
//             ))}
//             <div className="ss-add-variant-btn" onClick={handleAddVariant}>
//               + Add variant
//             </div>
//           </div>
//         </div>
//       </div>
//       <div className="ss-service-footer">
//         <span className="ss-save-hint">
//           Changes are auto-saved when you click Save
//         </span>
//         <div className="ss-footer-actions">
//           <button
//             className="ss-btn-ghost"
//             onClick={() => window.location.reload()}
//           >
//             Discard changes
//           </button>
//           <button className="ss-btn-save" onClick={handleSave}>
//             Save service
//           </button>
//         </div>
//       </div>
//     </div>
//   );
// };

// const SellarShop = () => {
//   const [data, setData] = useState([]);
//   const [serviceCatalog, setServiceCatalog] = useState([]);
//   const [businessProfile, setBusinessProfile] = useState({
//     companyName: "",
//     businessImage: "",
//     description: "",
//   });
//   const [userid, setUserid] = useState("");
//   const [isLoading, setIsLoading] = useState(true);
//   const [isPopupOpen, setIsPopupOpen] = useState(false);
//   const [editData, setEditData] = useState(null);
//   const [selectedShopId, setSelectedShopId] = useState("");
//   const [editingServiceIndex, setEditingServiceIndex] = useState(null);
//   const [showNewServiceEditor, setShowNewServiceEditor] = useState(false);
//   const businessImageInputRef = React.useRef(null);

//   // ── Confirm modal state ──
//   const [confirmModal, setConfirmModal] = useState({
//     isOpen: false,
//     title: "",
//     message: "",
//     onConfirm: null,
//   });

//   const openConfirm = (title, message, onConfirm) => {
//     setConfirmModal({ isOpen: true, title, message, onConfirm });
//   };

//   const closeConfirm = () => {
//     setConfirmModal({ isOpen: false, title: "", message: "", onConfirm: null });
//   };

//   useEffect(() => {
//     window.scrollTo(0, 0);
//     fetchData();
//     const storedUser = localStorage.getItem("user");
//     if (storedUser) {
//       const userObject = JSON.parse(storedUser);
//       setUserid(userObject?.id || "");
//     }
//   }, []);

//   useEffect(() => {
//     if (!selectedShopId && data.length > 0) setSelectedShopId(data[0]._id);
//   }, [data, selectedShopId]);

//   const selectedShop = useMemo(
//     () => data.find((item) => item._id === selectedShopId) || data[0] || null,
//     [data, selectedShopId],
//   );
//   const selectedLocation = selectedShop?.locations?.[0] || selectedShop || null;

//   const businessBannerImage =
//     businessProfile.businessImage ||
//     selectedShop?.Owner?.business?.businessImage ||
//     selectedShop?.coverImage ||
//     "";

//   const businessBannerName =
//     businessProfile.companyName ||
//     selectedShop?.Owner?.business?.companyName ||
//     selectedShop?.shopName ||
//     "Your Business";

//   const getLocationLabel = (shop, index = 0) => {
//     const candidates = [
//       shop?.display_name,
//       shop?.displayName,
//       shop?.location?.display_name,
//       shop?.location?.displayName,
//       shop?.locations?.[0]?.display_name,
//       shop?.locations?.[0]?.displayName,
//       shop?.locations?.[0]?.location?.display_name,
//       shop?.locations?.[0]?.location?.displayName,
//       shop?.locations?.[0]?.location?.text,
//       shop?.location?.text,
//       shop?.locations?.[0]?.city,
//       shop?.city,
//     ];

//     const resolved = candidates.find(
//       (value) => typeof value === "string" && value.trim(),
//     );

//     if (resolved) {
//       const trimmed = resolved.trim();
//       return trimmed.length > 30 ? `${trimmed.slice(0, 30)}...` : trimmed;
//     }

//     return `Location ${index + 1}`;
//   };

//   const fetchData = async () => {
//     const token = localStorage.getItem("accessToken");
//     try {
//       const profileResponse = await axios.get(
//         "https://backend.washta.com/api/seller/Profile",
//         {
//           headers: { Authorization: `Bearer ${token}` },
//         },
//       );
//       const profileBusiness = profileResponse?.data?.data?.business || {};
//       setBusinessProfile({
//         companyName: profileBusiness.companyName || "",
//         businessImage: profileBusiness.businessImage || "",
//         description: profileBusiness.description || "",
//       });

//       const response = await axios.get(
//         "https://backend.washta.com/api/seller/shop",
//         {
//           headers: { Authorization: `Bearer ${token}` },
//         },
//       );
//       const shopData = Array.isArray(response.data.data)
//         ? response.data.data.slice().reverse()
//         : [];
//       setData(shopData);
//       setSelectedShopId((currentSelectedShopId) => {
//         const stillExists = shopData.some((shop) => shop._id === currentSelectedShopId);
//         if (stillExists) return currentSelectedShopId;
//         return shopData[0]?._id || "";
//       });

//       const catalogResponse = await axios.get(
//         "https://backend.washta.com/api/seller/service-catalog",
//         {
//           headers: { Authorization: `Bearer ${token}` },
//         },
//       );
//       setServiceCatalog(Array.isArray(catalogResponse?.data?.data) ? catalogResponse.data.data : []);
//     } catch (error) {
//       console.log(error.message);
//     } finally {
//       setIsLoading(false);
//     }
//   };

//   const handleEditClick = (item) => {
//     setEditData(item);
//     setIsPopupOpen(true);
//   };
//   const togglePopup = () => {
//     setIsPopupOpen((p) => !p);
//     setEditData(null);
//   };

//   // ── Delete shop — confirmation pehle ──
//   const handleDeleteShop = (id, shopName) => {
//     openConfirm(
//       "Delete Location",
//       `Are you sure you want to delete "${shopName}" location? This action cannot be undone.`,
//       async () => {
//         closeConfirm();
//         const token = localStorage.getItem("accessToken");
//         try {
//           await axios.delete(
//             `https://backend.washta.com/api/seller/shop/${id}`,
//             {
//               headers: { Authorization: `Bearer ${token}` },
//             },
//           );
//           toast.success("Location deleted");
//           setData((prev) => prev.filter((item) => item._id !== id));
//           if (selectedShopId === id) setSelectedShopId("");
//         } catch {
//           toast.error("Failed to delete shop");
//         }
//       },
//     );
//   };

//   const handleSaveService = async (service, isNew) => {
//     if (!selectedShop) return;
//     const token = localStorage.getItem("accessToken");
//     const existingServices = Array.isArray(selectedLocation?.services)
//       ? selectedLocation.services
//       : [];
//     try {
//       if (isNew) {
//         await axios.patch(
//           `https://backend.washta.com/api/seller/shop/${selectedShop._id}`,
//           { services: [...existingServices, service], locationId: selectedLocation?._id },
//           { headers: { Authorization: `Bearer ${token}` } },
//         );
//         toast.success("Service added successfully");
//       } else {
//         const updated = [...existingServices];
//         updated[editingServiceIndex] = service;
//         await axios.patch(
//           `https://backend.washta.com/api/seller/shop/${selectedShop._id}`,
//           { services: updated, locationId: selectedLocation?._id },
//           { headers: { Authorization: `Bearer ${token}` } },
//         );
//         toast.success("Service updated successfully");
//       }
//       setShowNewServiceEditor(false);
//       setEditingServiceIndex(null);
//       await fetchData();
//     } catch (error) {
//       console.log('asdasdasdasd',error)
//       if (error.response?.status === 409) {
//     const apiMessage = error.response?.data?.data || "";
//     const serviceName = apiMessage.split(":").pop().trim();

//     toast.warning(
//       `The service "${serviceName}" already exists at the selected location. Please choose a different service or location.`
//     );
//   } else {
//     toast.error("Failed to save the service. Please try again.");
//   }
//       console.error(error);
//     }
//   };

//   const triggerBusinessImageInput = () => {
//     if (businessImageInputRef.current) {
//       businessImageInputRef.current.click();
//     }
//   };

//   const handleBusinessImageUpload = async (event) => {
//     const file = event.target.files?.[0];
//     if (!file) return;

//     if (file.size > 2 * 1024 * 1024) {
//       toast.error("Image size must be less than 2MB");
//       event.target.value = "";
//       return;
//     }

//     const token = localStorage.getItem("accessToken");
//     const uploadFormData = new FormData();
//     uploadFormData.append("file", file);

//     try {
//       const uploadResponse = await axios.post(
//         `${API_BASE_URL}/api/uploadFile`,
//         uploadFormData,
//         {
//           headers: {
//             "Content-Type": "multipart/form-data",
//             Authorization: `Bearer ${token}`,
//           },
//         },
//       );

//       const uploadedImageUrl = uploadResponse?.data?.data?.path;
//       if (!uploadedImageUrl) {
//         toast.error("Image upload failed");
//         return;
//       }

//       const profileResponse = await axios.get(
//         `${API_BASE_URL}/api/seller/Profile`,
//         {
//           headers: { Authorization: `Bearer ${token}` },
//         },
//       );
//       const currentBusiness = profileResponse?.data?.data?.business || {};

//       const payload = {
//         business: {
//           ...currentBusiness,
//           businessImage: uploadedImageUrl,
//         },
//       };

//       await axios.patch(`${API_BASE_URL}/api/seller/Profile`, payload, {
//         headers: { Authorization: `Bearer ${token}` },
//       });

//       setBusinessProfile((prev) => ({
//         ...prev,
//         businessImage: uploadedImageUrl,
//       }));
//       toast.success("Business image updated");
//       await fetchData();
//     } catch (error) {
//       toast.error(
//         error?.response?.data?.error ||
//           error?.response?.data?.message ||
//           "Image upload failed",
//       );
//     } finally {
//       event.target.value = "";
//     }
//   };

//   // ── Remove service — confirmation pehle ──
//   const handleRemoveService = (service) => {
//     openConfirm(
//       "Remove Service",
//       `Are you sure you want to remove "${service.serviceName}"?`,
//       async () => {
//         closeConfirm();
//         if (!selectedShop) return;
//         const token = localStorage.getItem("accessToken");
//         const existingServices = Array.isArray(selectedLocation?.services)
//           ? selectedLocation.services
//           : [];
//         const updated = existingServices.filter(
//           (s) => s.serviceName !== service.serviceName,
//         );
//         try {
//           await axios.patch(
//             `https://backend.washta.com/api/seller/shop/${selectedShop._id}`,
//             { services: updated, locationId: selectedLocation?._id },
//             { headers: { Authorization: `Bearer ${token}` } },
//           );
//           toast.success("Service removed successfully");
//           setEditingServiceIndex(null);
//           await fetchData();
//         } catch {
//           toast.error("Failed to remove service");
//         }
//       },
//     );
//   };

//   const services = Array.isArray(selectedLocation?.services)
//     ? selectedLocation.services
//     : [];

//   return (
//     <div className="mainDiv-all-sideBar ss-shell">
//       <div className="div-sidebar">
//         <Sidebar />
//       </div>

//       <div className="div-Dashbaord ss-content">
//         {isLoading ? (
//           <div>
//             <div className="ss-account-section">
//               <Skeleton variant="rounded" width={64} height={64} />
//               <div style={{ flex: 1 }}>
//                 <Skeleton variant="text" width="35%" height={30} />
//                 <Skeleton variant="text" width="55%" height={22} />
//                 <Skeleton variant="text" width="70%" height={18} />
//               </div>
//             </div>
//             <div className="ss-shop-strip">
//               {[0, 1, 2, 3].map((i) => (
//                 <Skeleton key={i} variant="rounded" width={112} height={30} />
//               ))}
//               <Skeleton variant="rounded" width={96} height={30} />
//             </div>
//             <div className="ss-loading-grid">
//               {[0, 1].map((i) => (
//                 <div key={i} className="ss-loading-card">
//                   <Skeleton variant="text" width="30%" height={20} />
//                   <Skeleton
//                     variant="rectangular"
//                     width="100%"
//                     height={56}
//                     sx={{ borderRadius: 2, mt: 1 }}
//                   />
//                   <Box sx={{ width: "100%", mt: 1 }}>
//                     <Skeleton variant="text" width="75%" height={24} />
//                     <Skeleton variant="text" width="55%" height={20} />
//                     <Skeleton
//                       variant="rectangular"
//                       width="100%"
//                       height={78}
//                       sx={{ borderRadius: 2, mt: 1 }}
//                     />
//                   </Box>
//                 </div>
//               ))}
//             </div>
//           </div>
//         ) : (
//           <>
//             {/* Account Banner */}
//             <div className="ss-account-section">
//               <div
//                 className="ss-account-logo-upload"
//                 onClick={triggerBusinessImageInput}
//                 role="button"
//                 tabIndex={0}
//                 onKeyDown={(event) => {
//                   if (event.key === "Enter" || event.key === " ") {
//                     event.preventDefault();
//                     triggerBusinessImageInput();
//                   }
//                 }}
//               >
//                 <input
//                   ref={businessImageInputRef}
//                   type="file"
//                   accept=".png,.jpg,.jpeg"
//                   style={{ display: "none" }}
//                   onChange={handleBusinessImageUpload}
//                 />
//                 <div className="ss-account-logo-initials">
//                   {businessBannerImage ? (
//                     <img
//                       src={businessBannerImage}
//                       alt={businessBannerName}
//                       style={{
//                         width: "100%",
//                         height: "100%",
//                         objectFit: "cover",
//                       }}
//                     />
//                   ) : (
//                     getInitials(businessBannerName)
//                   )}
//                 </div>
//                 <button type="button" className="ss-upload-overlay">
//                   Change
//                 </button>
//               </div>
//               <div className="ss-account-info">
//                 <div className="ss-account-name">
//                   {businessBannerName}
//                 </div>
//                 <div className="ss-account-desc">
//                   Service provider account · {data.length} active locations
//                 </div>
//                 <div className="ss-account-logo-note">
//                   ↑ This logo appears on all your service cards and booking
//                   pages in the customer app
//                 </div>
//                 <div className="ss-account-logo-spec">
//                   {businessProfile.description || "Square image · Min 200×200px · PNG or JPG · Max 2MB"}
//                 </div>
//               </div>
//             </div>

//             {/* Shop strip */}
//             <div className="ss-shop-strip">
//               {data.map((shop, index) => (
//                 <div
//                   key={shop._id}
//                   className={`ss-shop-chip-wrap ${selectedShopId === shop._id ? "active" : ""}`}
//                 >
//                   <button
//                     type="button"
//                     className={`ss-shop-chip ${selectedShopId === shop._id ? "active" : ""}`}
//                     onClick={() => setSelectedShopId(shop._id)}
//                   >
//                     {getLocationLabel(shop, index)}
//                   </button>
//                   <button
//                     type="button"
//                     className="ss-shop-delete"
//                     title={`Delete ${getLocationLabel(shop, index)}`}
//                     onClick={(e) => {
//                       e.stopPropagation();
//                       handleDeleteShop(shop._id, getLocationLabel(shop, index));
//                     }}
//                   >
//                     <MdDeleteOutline />
//                   </button>
//                 </div>
//               ))}
//               <button
//                 type="button"
//                 className="ss-shop-add"
//                 onClick={togglePopup}
//               >
//                 + Add location
//               </button>
//             </div>

//             {selectedShop ? (
//               <>
//                 <div className="ss-section-header">
//                   <div className="ss-section-title">
//                     Services at {getLocationLabel(selectedShop)}
//                   </div>
//                   <div className="ss-footer-actions">
//                     <button
//                       className="ss-btn-secondary"
//                       onClick={() => handleEditClick(selectedShop)}
//                     >
//                       <FiEdit2 /> Edit
//                     </button>
//                     <button
//                       className="ss-btn-primary"
//                       onClick={() => {
//                         setShowNewServiceEditor(true);
//                         setEditingServiceIndex(null);
//                       }}
//                     >
//                       + Add service
//                     </button>
//                   </div>
//                 </div>

//                 <div
//                   className="ss-account-logo-spec"
//                   style={{ marginBottom: "12px" }}
//                 >
//                   You can edit this location anytime: working hours, radius,
//                   location pin and location-specific services.
//                 </div>

//                 <div>
//                   {showNewServiceEditor && (
//                     <ServiceEditor
//                       service={createBlankService()}
//                       onSave={(service) => handleSaveService(service, true)}
//                       onRemove={() => setShowNewServiceEditor(false)}
//                       catalogOptions={serviceCatalog}
//                       isNew={true}
//                     />
//                   )}

//                   {services.map((service, index) =>
//                     editingServiceIndex === index ? (
//                       <ServiceEditor
//                         key={index}
//                         service={service}
//                         onSave={(s) => handleSaveService(s, false)}
//                         onRemove={() => handleRemoveService(service)}
//                         catalogOptions={serviceCatalog}
//                         isNew={false}
//                       />
//                     ) : (
//                       <div key={index} className="ss-service-card ss-readonly">
//                         <div className="ss-svc-header">
//                           <div className="ss-svc-name-block">
//                             <div className="ss-field-label">
//                               Service name (shown on app)
//                             </div>
//                             <div className="ss-readonly-input ss-bold">
//                               {service.serviceName}
//                             </div>
//                           </div>
//                           <div className="ss-svc-actions">
//                             <span
//                               className="ss-action-link"
//                               onClick={() => setEditingServiceIndex(index)}
//                             >
//                               Edit
//                             </span>
//                             <span
//                               className="ss-action-link ss-danger"
//                               onClick={() => handleRemoveService(service)}
//                             >
//                               Remove
//                             </span>
//                           </div>
//                         </div>
//                         <div className="ss-svc-body">
//                           <div className="ss-svc-top-row">
//                             <div className="ss-svc-image-col">
//                               <div className="ss-field-label">
//                                 Service card image
//                               </div>
//                               {service.heroImageUrl ? (
//                                 <div className="ss-upload-preview">
//                                   <img
//                                     src={service.heroImageUrl}
//                                     alt={service.serviceName}
//                                     style={{
//                                       width: "100%",
//                                       height: "100%",
//                                       objectFit: "cover",
//                                     }}
//                                   />
//                                 </div>
//                               ) : (
//                                 <div className="ss-upload-preview placeholder">
//                                   🖼️
//                                 </div>
//                               )}
//                             </div>
//                             <div className="ss-svc-details-col">
//                               <div className="ss-field-label">
//                                 Car types supported
//                               </div>
//                               <div className="ss-car-types-row">
//                                 {service.supportedCarTypes &&
//                                 service.supportedCarTypes.length > 0 ? (
//                                   service.supportedCarTypes.map((type) => (
//                                     <span key={type} className="ss-car-chip on">
//                                       <div className="ss-checkbox">✓</div>
//                                       {type}
//                                     </span>
//                                   ))
//                                 ) : (
//                                   <span>No car types selected</span>
//                                 )}
//                               </div>
//                               {service.customCarTypes &&
//                                 service.customCarTypes.length > 0 && (
//                                   <div style={{ marginTop: "8px" }}>
//                                     <div className="ss-field-label">
//                                       Custom car types
//                                     </div>
//                                     <div className="ss-car-types-row">
//                                       {service.customCarTypes.map((type) => (
//                                         <span
//                                           key={type}
//                                           className="ss-car-chip on"
//                                         >
//                                           <div className="ss-checkbox">✓</div>
//                                           {type}
//                                         </span>
//                                       ))}
//                                     </div>
//                                   </div>
//                                 )}
//                             </div>
//                           </div>
//                           <div className="ss-divider"></div>
//                           <div>
//                             <div className="ss-field-label">
//                               Service variants ({service.variants?.length || 0})
//                             </div>
//                             {service.variants &&
//                               service.variants.map((v, i) => (
//                                 <div
//                                   key={i}
//                                   style={{
//                                     fontSize: "12px",
//                                     color: "#666",
//                                     marginTop: "8px",
//                                     padding: "8px",
//                                     backgroundColor: "#f5f5f5",
//                                     borderRadius: "6px",
//                                   }}
//                                 >
//                                   <strong>{v.variantName}</strong> -{" "}
//                                   {v.variantType}
//                                 </div>
//                               ))}
//                           </div>
//                         </div>
//                       </div>
//                     ),
//                   )}

//                   {services.length === 0 && !showNewServiceEditor && (
//                     <div className="ss-empty-state">
//                       <h3>No services yet</h3>
//                       <p>
//                         Add your first service to start building your shop
//                         catalog.
//                       </p>
//                       <button
//                         className="ss-btn-primary"
//                         onClick={() => setShowNewServiceEditor(true)}
//                       >
//                         + Add service
//                       </button>
//                     </div>
//                   )}
//                 </div>
//               </>
//             ) : null}
//           </>
//         )}

//         {isPopupOpen && (
//           <PopupSellar
//             fetchData={fetchData}
//             id={userid}
//             Cross={togglePopup}
//             editData={editData}
//           />
//         )}

//         {/* Confirm Modal */}
//         <ConfirmModal
//           isOpen={confirmModal.isOpen}
//           title={confirmModal.title}
//           message={confirmModal.message}
//           onConfirm={confirmModal.onConfirm}
//           onCancel={closeConfirm}
//         />

//         <ToastContainer />
//       </div>
//     </div>
//   );
// };

// export default SellarShop;

import Sidebar from "pages/sideBar/SideBar";
import React, { useEffect, useMemo, useState } from "react";
import "../app.css";
import "./SellarShop.css";
import PopupSellar from "./popupsellar";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import { Box, Skeleton } from "@mui/material";
import { FiEdit2 } from "react-icons/fi";
import { MdDeleteOutline } from "react-icons/md";

const API_BASE_URL = "https://backend.washta.com";

/* ─────────────────────────────────────────────
   Constants
───────────────────────────────────────────── */
const CAR_TYPE_OPTIONS = ["Sedan", "SUV", "Van", "Motorcycle", "Truck"];
const VEHICLE_TYPES = {
  Sedan: "sedan",
  SUV: "suv",
  Van: "van",
  Motorcycle: "motorcycle",
  Truck: "truck",
};

const buildCarPricingFromTypes = (types = [], existingPricing = []) => {
  const normalizedTypes = Array.isArray(types)
    ? types.map((type) => String(type).trim()).filter(Boolean)
    : [];
  return normalizedTypes.map((type) => {
    const existing = (
      Array.isArray(existingPricing) ? existingPricing : []
    ).find((item) => item?.carName === type);
    return {
      carName: type,
      vehicleType:
        VEHICLE_TYPES[type] || type.toLowerCase().replace(/\s+/g, "_"),
      price: existing?.price ?? "",
    };
  });
};

/* ─────────────────────────────────────────────
   Helper: Create blank service
───────────────────────────────────────────── */
const createBlankService = () => ({
  serviceName: "",
  catalogId: "",
  category: "exterior",
  heroImageUrl: "",
  supportedCarTypes: ["Sedan", "SUV"],
  customCarTypes: [],
  variants: [
    {
      variantName: "",
      variantType: "stationed",
      badgeText: "",
      parkingPrompt: "",
      estimatedTime: 30,
      estimatedTimeUnit: "minutes",
      samePriceForAllCars: false,
      basePrice: "",
      carPricing: [
        { carName: "Sedan", vehicleType: "sedan", price: "" },
        { carName: "SUV", vehicleType: "suv", price: "" },
      ],
      addOns: [{ name: "", price: "", isActive: true }],
      isActive: true,
    },
  ],
  isActive: true,
});

const getInitials = (value) => {
  const text = typeof value === "string" ? value.trim() : "";
  if (!text) return "?";

  const parts = text.split(/\s+/).filter(Boolean);
  const initials = parts
    .slice(0, 2)
    .map((part) => part[0])
    .join("")
    .toUpperCase();

  return initials || text.slice(0, 2).toUpperCase();
};

/* ─────────────────────────────────────────────
   Confirm Modal
───────────────────────────────────────────── */
const ConfirmModal = ({ isOpen, title, message, onConfirm, onCancel }) => {
  if (!isOpen) return null;
  return (
    <div className="ss-modal-overlay" onClick={onCancel}>
      <div className="ss-modal-box" onClick={(e) => e.stopPropagation()}>
        <div className="ss-modal-title">{title}</div>
        <div className="ss-modal-message">{message}</div>
        <div className="ss-modal-actions">
          <button className="ss-modal-btn-cancel" onClick={onCancel}>
            Cancel
          </button>
          <button className="ss-modal-btn-confirm" onClick={onConfirm}>
            Yes, Delete
          </button>
        </div>
      </div>
    </div>
  );
};

const Toggle = ({ checked, onChange }) => (
  <button
    type="button"
    role="switch"
    aria-checked={checked}
    className={`ss-mini-toggle ${checked ? "on" : ""}`}
    onClick={() => onChange(!checked)}
  >
    <span className="ss-toggle-knob"></span>
  </button>
);
const CarTypeChips = ({
  selected,
  customTypes = [],
  onChange,
  onCustomTypesChange,
}) => {
  const [showCustomInput, setShowCustomInput] = useState(false);
  const [customValue, setCustomValue] = useState("");
  const allTypes = [
    ...CAR_TYPE_OPTIONS,
    ...customTypes.filter((type) => !CAR_TYPE_OPTIONS.includes(type)),
  ];

  const toggle = (type) => {
    const next = selected.includes(type)
      ? selected.filter((t) => t !== type)
      : [...selected, type];
    onChange(next);
  };

  const handleAddCustom = () => {
    const value = customValue.trim();
    if (!value) return;

    const existingCustomTypes = Array.isArray(customTypes) ? customTypes : [];
    const alreadyExists = [...CAR_TYPE_OPTIONS, ...existingCustomTypes].some(
      (item) => item.toLowerCase() === value.toLowerCase(),
    );

    const nextCustomTypes = alreadyExists
      ? existingCustomTypes
      : [...existingCustomTypes, value];

    const alreadySelected = selected.some(
      (item) => item.toLowerCase() === value.toLowerCase(),
    );
    const nextSelected = alreadySelected ? selected : [...selected, value];

    onCustomTypesChange(nextCustomTypes, nextSelected);

    setCustomValue("");
    setShowCustomInput(false);
  };

  return (
    <div>
      <div className="ss-car-types-row">
        {allTypes.map((type) => {
          const on = selected.includes(type);
          return (
            <button
              key={type}
              type="button"
              className={`ss-car-chip ${on ? "on" : ""}`}
              onClick={() => toggle(type)}
            >
              <div className="ss-checkbox">{on ? "✓" : ""}</div>
              {type}
            </button>
          );
        })}
        <button
          type="button"
          className="ss-car-chip custom"
          onClick={() => setShowCustomInput((prev) => !prev)}
        >
          + Custom
        </button>
      </div>
      {showCustomInput && (
        <div className="ss-custom-car-row">
          <input
            className="ss-custom-car-input"
            placeholder="Custom car type"
            value={customValue}
            onChange={(e) => setCustomValue(e.target.value)}
            onKeyDown={(e) => {
              if (e.key === "Enter") {
                e.preventDefault();
                handleAddCustom();
              }
            }}
          />
          <button type="button" className="ss-btn-sm" onClick={handleAddCustom}>
            Add
          </button>
        </div>
      )}
    </div>
  );
};

/* ─────────────────────────────────────────────
   Sub-components: Variant Editor
───────────────────────────────────────────── */
const VariantEditor = ({ variant, index, onUpdate, onRemove }) => {
  const handleUpdate = (field, value) => {
    onUpdate(index, { ...variant, [field]: value });
  };

  const handleCarPricingUpdate = (priceIndex, field, value) => {
    const updated = variant.carPricing.map((item, i) =>
      i === priceIndex ? { ...item, [field]: value } : item,
    );
    handleUpdate("carPricing", updated);
  };

  const handleAddOnUpdate = (addonIndex, field, value) => {
    const updated = variant.addOns.map((item, i) =>
      i === addonIndex ? { ...item, [field]: value } : item,
    );
    handleUpdate("addOns", updated);
  };

  const handleAddOnAdd = () => {
    const nextAddons = [
      ...(Array.isArray(variant.addOns) ? variant.addOns : []),
      { name: "", price: "", isActive: true },
    ];
    handleUpdate("addOns", nextAddons);
  };

  const handleAddCarPricingRow = () => {
    const nextRows = [
      ...(Array.isArray(variant.carPricing) ? variant.carPricing : []),
      { carName: "", vehicleType: "custom", price: "" },
    ];
    handleUpdate("carPricing", nextRows);
  };

  const handleRemoveCarPricingRow = (rowIndex) => {
    const currentRows = Array.isArray(variant.carPricing)
      ? variant.carPricing
      : [];
    if (currentRows.length <= 1) {
      toast.error("At least one car price row is required");
      return;
    }
    handleUpdate(
      "carPricing",
      currentRows.filter((_, i) => i !== rowIndex),
    );
  };

  const handleCarNameChange = (priceIndex, value) => {
    const nextVehicleType = value.trim().toLowerCase().replace(/\s+/g, "_");
    const updated = variant.carPricing.map((item, i) =>
      i === priceIndex
        ? { ...item, carName: value, vehicleType: nextVehicleType || "custom" }
        : item,
    );
    handleUpdate("carPricing", updated);
  };

  return (
    <div className="ss-variant-card">
      <div className="ss-variant-head">
        <div className="ss-field-label">Variant name (shown on app)</div>
        <select
          className="ss-variant-type-select"
          value={variant.variantType}
          onChange={(e) => handleUpdate("variantType", e.target.value)}
        >
          <option value="stationed">Stationed — customer parks</option>
          <option value="mobile">Mobile — we go to customer</option>
        </select>
        {index > 0 && (
          <span className="ss-variant-remove" onClick={() => onRemove(index)}>
            ✕ Remove
          </span>
        )}
      </div>
      <div className="ss-variant-body">
        <div>
          <input
            className="ss-edit-input"
            value={variant.variantName}
            onChange={(e) => handleUpdate("variantName", e.target.value)}
            placeholder="e.g. Exterior only"
          />
        </div>
        <div>
          <div className="ss-field-label">Badge text (shown on app)</div>
          <div className="ss-badge-row">
            {variant.badgeText && (
              <span className="ss-badge-pill">{variant.badgeText}</span>
            )}
            <input
              className="ss-edit-input"
              style={{ flex: 1 }}
              value={variant.badgeText}
              onChange={(e) => handleUpdate("badgeText", e.target.value)}
              placeholder={
    variant.variantType === "stationed"
      ? "e.g. Park At Station"
      : "e.g. We come to you"
  }
            />
          </div>
        </div>
        {variant.variantType === "stationed" && (
          <div>
            <div className="ss-field-label">Parking prompt (customer sees this)</div>
            <input
              className="ss-edit-input"
              value={variant.parkingPrompt}
              onChange={(e) => handleUpdate("parkingPrompt", e.target.value)}
              placeholder="Tell the customer where to park or meet you"
            />
          </div>
        )}
        <div>
          <div className="ss-field-label">Estimated Time</div>
          <div style={{ display: "flex", gap: "10px", alignItems: "flex-end" }}>
            <div style={{ flex: 1 }}>
              <input
                className="ss-edit-input"
                type="number"
                min="1"
                value={variant.estimatedTime || ""}
                onChange={(e) => handleUpdate("estimatedTime", Number(e.target.value))}
                placeholder="e.g. 45"
                style={{border:'1px solid #ddd',padding:'6px 10px',borderRadius:'7px'}}
              />
            </div>
            <select
              className="ss-edit-input"
              value={variant.estimatedTimeUnit || "minutes"}
              onChange={(e) => handleUpdate("estimatedTimeUnit", e.target.value)}
              style={{ flex: 0, minWidth: "120px", marginBottom: "0" }}
            >
              <option value="minutes">Minutes</option>
              <option value="hours">Hours</option>
            </select>
          </div>
        </div>
        <div>
          <div className="ss-field-label">Pricing</div>
          <div className="ss-same-price-row">
            <Toggle
              checked={variant.samePriceForAllCars}
              onChange={(val) => handleUpdate("samePriceForAllCars", val)}
            />
            <span className="ss-toggle-label">
              Same price for all car types
            </span>
          </div>
          <div className="ss-price-matrix">
            {variant.samePriceForAllCars ? (
              <div className="ss-price-row">
                <span className="ss-price-car">All car types</span>
                <div className="ss-price-wrap">
                  <span className="ss-price-cur">AED</span>
                  <input
                    className="ss-price-input"
                    type="number"
                    min="0"
                    value={variant.basePrice}
                    onChange={(e) => handleUpdate("basePrice", e.target.value)}
                  />
                </div>
              </div>
            ) : (
              variant.carPricing.map((car, i) => (
                <div key={i} className="ss-price-row">
                  <input
                    className="ss-price-car-input"
                    value={car.carName}
                    onChange={(e) => handleCarNameChange(i, e.target.value)}
                    placeholder="Car type"
                  />
                  <div className="ss-price-wrap">
                    <span className="ss-price-cur">AED</span>
                    <input
                      className="ss-price-input"
                      type="number"
                      min="0"
                      value={car.price}
                      onChange={(e) =>
                        handleCarPricingUpdate(i, "price", e.target.value)
                      }
                    />
                  </div>
                  <span
                    className="ss-addon-remove"
                    onClick={() => handleRemoveCarPricingRow(i)}
                  >
                    ✕
                  </span>
                </div>
              ))
            )}
          </div>
          {/* {!variant.samePriceForAllCars && (
            <button
              type="button"
              className="ss-btn-sm ss-compact-btn"
              onClick={handleAddCarPricingRow}
            >
              + Add car type
            </button>
          )} */}
        </div>
        <div className="ss-addons-block">
          <div className="ss-addons-header">
            <div className="ss-addons-title">Add-ons for this variant</div>
            <span className="ss-addons-add" onClick={handleAddOnAdd}>
              + Add
            </span>
          </div>
          {(Array.isArray(variant.addOns) ? variant.addOns : []).map(
            (addon, i) => (
              <div key={i} className="ss-addon-item">
                <input
                  className="ss-addon-name-input"
                  value={addon.name}
                  onChange={(e) => handleAddOnUpdate(i, "name", e.target.value)}
                  placeholder="Air freshener"
                />
                <div className="ss-addon-price-wrap">
                  <span className="ss-addon-price-cur">AED</span>
                  <input
                    className="ss-addon-price-input"
                    type="number"
                    min="0"
                    value={addon.price}
                    onChange={(e) =>
                      handleAddOnUpdate(i, "price", e.target.value)
                    }
                  />
                </div>
                <Toggle
                  checked={addon.isActive}
                  onChange={(val) => handleAddOnUpdate(i, "isActive", val)}
                />
                <span
                  className="ss-addon-remove"
                  onClick={() => {
                    const updated = variant.addOns.filter(
                      (_, idx) => idx !== i,
                    );
                    handleUpdate("addOns", updated);
                  }}
                >
                  ✕
                </span>
              </div>
            ),
          )}
        </div>
      </div>
    </div>
  );
};

/* ─────────────────────────────────────────────
   Sub-components: Service Editor (inline)
───────────────────────────────────────────── */
const ServiceEditor = ({ service, onSave, onRemove, isNew, catalogOptions = [] }) => {
  const [draft, setDraft] = useState(service);
  const [isImageUploading, setIsImageUploading] = useState(false);
  const imageInputRef = React.useRef(null);

  const handleUpdate = (field, value) => setDraft({ ...draft, [field]: value });

  const handleVariantUpdate = (index, variant) => {
    const updated = draft.variants.map((v, i) => (i === index ? variant : v));
    setDraft({ ...draft, variants: updated });
  };

  // const applySupportedTypesToVariants = (
  //   nextSupportedTypes,
  //   nextCustomTypes = draft.customCarTypes || [],
  // ) => {
  //   const resolvedTypes = Array.from(
  //     new Set([...(nextSupportedTypes || []), ...(nextCustomTypes || [])]),
  //   );
  //   const updatedVariants = (
  //     Array.isArray(draft.variants) ? draft.variants : []
  //   ).map((variant) => {
  //     if (variant.samePriceForAllCars) return variant;
  //     return {
  //       ...variant,
  //       carPricing: buildCarPricingFromTypes(resolvedTypes, variant.carPricing),
  //     };
  //   });
  //   setDraft((prev) => ({
  //     ...prev,
  //     supportedCarTypes: nextSupportedTypes,
  //     customCarTypes: nextCustomTypes,
  //     variants: updatedVariants,
  //   }));
  // };
const applySupportedTypesToVariants = (
  nextSupportedTypes,
  nextCustomTypes = draft.customCarTypes || [],
) => {
  const resolvedTypes = Array.from(new Set(nextSupportedTypes || []));

  const updatedVariants = (
    Array.isArray(draft.variants) ? draft.variants : []
  ).map((variant) => {
    if (variant.samePriceForAllCars) return variant;
    return {
      ...variant,
      carPricing: buildCarPricingFromTypes(resolvedTypes, variant.carPricing),
    };
  });
  setDraft((prev) => ({
    ...prev,
    supportedCarTypes: nextSupportedTypes,
    customCarTypes: nextCustomTypes,
    variants: updatedVariants,
  }));
};
  const handleVariantRemove = (index) => {
    if (draft.variants.length > 1) {
      setDraft({
        ...draft,
        variants: draft.variants.filter((_, i) => i !== index),
      });
    } else {
      toast.error("Service must have at least one variant");
    }
  };

  const handleAddVariant = () => {
    const availableTypes = Array.from(
      new Set([
        ...(Array.isArray(draft.supportedCarTypes)
          ? draft.supportedCarTypes
          : []),
        ...(Array.isArray(draft.customCarTypes) ? draft.customCarTypes : []),
      ]),
    );
    const newVariant = {
      variantName: "",
      variantType: "stationed",
      badgeText: "",
      parkingPrompt: "",
      samePriceForAllCars: false,
      basePrice: "",
      carPricing: buildCarPricingFromTypes(
        availableTypes.length > 0 ? availableTypes : ["Sedan", "SUV"],
      ),
      addOns: [],
      isActive: true,
    };
    setDraft({ ...draft, variants: [...draft.variants, newVariant] });
  };

  const triggerImageInput = () => {
    if (imageInputRef.current) imageInputRef.current.click();
  };

  const handleServiceImageUpload = async (event) => {
    const file = event.target.files?.[0];
    if (!file) return;
    if (file.size > 5 * 1024 * 1024) {
      toast.error("Image size must be less than 5MB");
      return;
    }
    const token = localStorage.getItem("accessToken");
    const uploadFormData = new FormData();
    uploadFormData.append("file", file);
    setIsImageUploading(true);
    try {
      const uploadResponse = await axios.post(
        `${API_BASE_URL}/api/uploadFile`,
        uploadFormData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${token}`,
          },
        },
      );
      const uploadedImageUrl = uploadResponse?.data?.data?.path;
      if (!uploadedImageUrl) {
        toast.error("Image upload failed");
        return;
      }
      setDraft((prev) => ({ ...prev, heroImageUrl: uploadedImageUrl }));
      toast.success("Service image uploaded");
    } catch (error) {
      toast.error(
        error?.response?.data?.error ||
          error?.response?.data?.message ||
          "Image upload failed",
      );
    } finally {
      setIsImageUploading(false);
      event.target.value = "";
    }
  };

  const handleSave = async () => {
    if (!draft.serviceName.trim()) {
      toast.error("Service name is required");
      return;
    }
    if (draft.variants.some((v) => !v.variantName.trim())) {
      toast.error("All variants must have a name");
      return;
    }
    const normalized = {
      ...draft,
      variants: (Array.isArray(draft.variants) ? draft.variants : []).map((v) => {
        if (v.variantType !== "stationed") {
          const { parkingPrompt, ...rest } = v;
          return rest;
        }
        return v;
      }),
    };
    onSave(normalized);
  };

  return (
    <div className="ss-service-card">
      <div className="ss-svc-header">
        <div className="ss-svc-name-block">
          <div className="ss-field-label">Service name (shown on app)</div>
          <select
            className="ss-edit-input"
            value={draft.catalogId || draft.serviceName || ""}
            onChange={(e) => {
              const value = e.target.value;
              const selectedCatalog = catalogOptions.find(
                (item) => String(item.slug || item._id || item.name) === String(value),
              );
              setDraft((prev) => ({
                ...prev,
                catalogId: value,
                serviceName: selectedCatalog?.name || prev.serviceName,
                heroImageUrl: selectedCatalog?.default_image_url || prev.heroImageUrl,
              }));
            }}
          >
            <option value="">Select service type</option>
            {catalogOptions.map((item) => (
              <option key={item._id || item.slug || item.name} value={String(item.slug || item._id || item.name)}>
                {item.name}
              </option>
            ))}
          </select>
          {/* <input
            className="ss-edit-input ss-bold"
            value={draft.serviceName}
            onChange={(e) => handleUpdate("serviceName", e.target.value)}
            placeholder="Carwash"
          /> */}
        </div>
        <div className="ss-svc-actions">
          <span className="ss-action-link">↕ Reorder</span>
          {!isNew && (
            <span
              className="ss-action-link ss-danger"
              onClick={() => onRemove(draft)}
            >
              Remove
            </span>
          )}
        </div>
      </div>
      <div className="ss-svc-body">
        <div className="ss-svc-top-row">
          {/* <div className="ss-svc-image-col">
            <div className="ss-field-label">
              Service card image (home screen)
            </div>
            <input
              ref={imageInputRef}
              type="file"
              accept=".png,.jpg,.jpeg"
              style={{ display: "none" }}
              onChange={handleServiceImageUpload}
            />
            {draft.heroImageUrl ? (
              <div className="ss-upload-preview" onClick={triggerImageInput}>
                <img
                  src={draft.heroImageUrl}
                  alt={draft.serviceName}
                  style={{ width: "100%", height: "100%", objectFit: "cover" }}
                />
                <div className="ss-upload-preview-overlay">
                  {isImageUploading ? "Uploading..." : "Change image"}
                </div>
              </div>
            ) : (
              <div className="ss-image-upload-zone" onClick={triggerImageInput}>
                <div className="ss-upload-icon">🖼️</div>
                <div className="ss-upload-title">
                  {isImageUploading ? "Uploading..." : "Upload service image"}
                </div>
                <div className="ss-upload-spec">
                  800×400px · Max 5MB · JPG or PNG
                </div>
              </div>
            )}
            <div className="ss-upload-actions">
              <button
                type="button"
                className="ss-upload-btn-sm"
                onClick={triggerImageInput}
              >
                Change
              </button>
              <button
                type="button"
                className="ss-upload-btn-sm ss-danger"
                onClick={() =>
                  setDraft((prev) => ({ ...prev, heroImageUrl: "" }))
                }
              >
                Remove
              </button>
            </div>
            <div style={{ fontSize: "9px", color: "#aaa", marginTop: "5px" }}>
              800×400px · Max 5MB · JPG or PNG
            </div>
          </div> */}
          <div className="ss-svc-details-col">
            <div>
              <div className="ss-field-label">Car types supported</div>
              <CarTypeChips
                selected={draft.supportedCarTypes}
                customTypes={draft.customCarTypes || []}
                onChange={(nextSelected) => {
                  applySupportedTypesToVariants(
                    nextSelected,
                    draft.customCarTypes || [],
                  );
                }}
                // ✅ nextSelected bhi saath aa raha hai — dono ek hi call mein sync
                onCustomTypesChange={(nextCustomTypes, nextSelected) => {
                  const normalizedCustom = Array.from(
                    new Set(
                      nextCustomTypes
                        .map((item) => item.trim())
                        .filter(Boolean),
                    ),
                  );
                  const resolvedSelected =
                    nextSelected ||
                    Array.from(
                      new Set([
                        ...(draft.supportedCarTypes || []),
                        ...normalizedCustom,
                      ]),
                    );
                  applySupportedTypesToVariants(
                    resolvedSelected,
                    normalizedCustom,
                  );
                }}
              />
            </div>
          </div>
        </div>
        <div className="ss-divider"></div>
        <div>
          <div className="ss-field-label">Service variants</div>
          <div className="ss-variants-col">
            {draft.variants.map((variant, i) => (
              <VariantEditor
                key={i}
                variant={variant}
                index={i}
                onUpdate={handleVariantUpdate}
                onRemove={handleVariantRemove}
              />
            ))}
            <div className="ss-add-variant-btn" onClick={handleAddVariant}>
              + Add variant
            </div>
          </div>
        </div>
      </div>
      <div className="ss-service-footer">
        <span className="ss-save-hint">
          Changes are auto-saved when you click Save
        </span>
        <div className="ss-footer-actions">
          <button
            className="ss-btn-ghost"
            onClick={() => window.location.reload()}
          >
            Discard changes
          </button>
          <button className="ss-btn-save" onClick={handleSave}>
            Save service
          </button>
        </div>
      </div>
    </div>
  );
};

const SellarShop = () => {
  const [data, setData] = useState([]);
  const [serviceCatalog, setServiceCatalog] = useState([]);
  const [businessProfile, setBusinessProfile] = useState({
    companyName: "",
    businessImage: "",
    description: "",
  });
  const [userid, setUserid] = useState("");
  const [isLoading, setIsLoading] = useState(true);
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [editData, setEditData] = useState(null);
  const [selectedShopId, setSelectedShopId] = useState("");
  const [editingServiceIndex, setEditingServiceIndex] = useState(null);
  const [showNewServiceEditor, setShowNewServiceEditor] = useState(false);
  const [togglingShopId, setTogglingShopId] = useState(null);
  const businessImageInputRef = React.useRef(null);

  // ── Confirm modal state ──
  const [confirmModal, setConfirmModal] = useState({
    isOpen: false,
    title: "",
    message: "",
    onConfirm: null,
  });

  const openConfirm = (title, message, onConfirm) => {
    setConfirmModal({ isOpen: true, title, message, onConfirm });
  };

  const closeConfirm = () => {
    setConfirmModal({ isOpen: false, title: "", message: "", onConfirm: null });
  };

  useEffect(() => {
    window.scrollTo(0, 0);
    fetchData();
    const storedUser = localStorage.getItem("user");
    if (storedUser) {
      const userObject = JSON.parse(storedUser);
      setUserid(userObject?.id || "");
    }
  }, []);

  useEffect(() => {
    if (!selectedShopId && data.length > 0) setSelectedShopId(data[0]._id);
  }, [data, selectedShopId]);

  const selectedShop = useMemo(
    () => data.find((item) => item._id === selectedShopId) || data[0] || null,
    [data, selectedShopId],
  );
  const selectedLocation = selectedShop?.locations?.[0] || selectedShop || null;

  const businessBannerImage =
    businessProfile.businessImage ||
    selectedShop?.Owner?.business?.businessImage ||
    selectedShop?.coverImage ||
    "";

  const businessBannerName =
    businessProfile.companyName ||
    selectedShop?.Owner?.business?.companyName ||
    selectedShop?.shopName ||
    "Your Business";

  const getLocationLabel = (shop, index = 0) => {
    const candidates = [
      shop?.display_name,
      shop?.displayName,
      shop?.location?.display_name,
      shop?.location?.displayName,
      shop?.locations?.[0]?.display_name,
      shop?.locations?.[0]?.displayName,
      shop?.locations?.[0]?.location?.display_name,
      shop?.locations?.[0]?.location?.displayName,
      shop?.locations?.[0]?.location?.text,
      shop?.location?.text,
      shop?.locations?.[0]?.city,
      shop?.city,
    ];

    const resolved = candidates.find(
      (value) => typeof value === "string" && value.trim(),
    );

    if (resolved) {
      const trimmed = resolved.trim();
      return trimmed.length > 30 ? `${trimmed.slice(0, 30)}...` : trimmed;
    }

    return `Location ${index + 1}`;
  };

  const fetchData = async () => {
    const token = localStorage.getItem("accessToken");
    try {
      const profileResponse = await axios.get(
        "https://backend.washta.com/api/seller/Profile",
        {
          headers: { Authorization: `Bearer ${token}` },
        },
      );
      const profileBusiness = profileResponse?.data?.data?.business || {};
      setBusinessProfile({
        companyName: profileBusiness.companyName || "",
        businessImage: profileBusiness.businessImage || "",
        description: profileBusiness.description || "",
      });

      const response = await axios.get(
        "https://backend.washta.com/api/seller/shop",
        {
          headers: { Authorization: `Bearer ${token}` },
        },
      );
      const shopData = Array.isArray(response.data.data)
        ? response.data.data.slice().reverse()
        : [];
      setData(shopData);
      setSelectedShopId((currentSelectedShopId) => {
        const stillExists = shopData.some((shop) => shop._id === currentSelectedShopId);
        if (stillExists) return currentSelectedShopId;
        return shopData[0]?._id || "";
      });

      const catalogResponse = await axios.get(
        "https://backend.washta.com/api/seller/service-catalog",
        {
          headers: { Authorization: `Bearer ${token}` },
        },
      );
      setServiceCatalog(Array.isArray(catalogResponse?.data?.data) ? catalogResponse.data.data : []);
    } catch (error) {
      console.log(error.message);
    } finally {
      setIsLoading(false);
    }
  };

  const handleEditClick = (item) => {
    setEditData(item);
    setIsPopupOpen(true);
  };

  const handleToggleShopActive = async (shop) => {
    const token = localStorage.getItem("accessToken");
    setTogglingShopId(shop._id);
    try {
      const res = await axios.patch(
        `https://backend.washta.com/api/seller/shop/${shop._id}/toggle`,
        {},
        { headers: { Authorization: `Bearer ${token}` } }
      );
      const updated = res.data?.data;
      setData((prev) =>
        prev.map((s) => (s._id === shop._id ? { ...s, isActive: updated.isActive } : s))
      );
      toast.success(updated.isActive ? "Shop is now active" : "Shop is now inactive");
    } catch {
      toast.error("Failed to update shop status");
    } finally {
      setTogglingShopId(null);
    }
  };
  const togglePopup = () => {
    setIsPopupOpen((p) => !p);
    setEditData(null);
  };

  // ── Delete shop — confirmation pehle ──
  const handleDeleteShop = (id, shopName) => {
    openConfirm(
      "Delete Location",
      `Are you sure you want to delete "${shopName}" location? This action cannot be undone.`,
      async () => {
        closeConfirm();
        const token = localStorage.getItem("accessToken");
        try {
          await axios.delete(
            `https://backend.washta.com/api/seller/shop/${id}`,
            {
              headers: { Authorization: `Bearer ${token}` },
            },
          );
          toast.success("Location deleted");
          setData((prev) => prev.filter((item) => item._id !== id));
          if (selectedShopId === id) setSelectedShopId("");
        } catch {
          toast.error("Failed to delete shop");
        }
      },
    );
  };

  const handleSaveService = async (service, isNew) => {
    if (!selectedShop) return;
    const token = localStorage.getItem("accessToken");
    const existingServices = Array.isArray(selectedLocation?.services)
      ? selectedLocation.services
      : [];
    try {
      if (isNew) {
        await axios.patch(
          `https://backend.washta.com/api/seller/shop/${selectedShop._id}`,
          { services: [...existingServices, service], locationId: selectedLocation?._id },
          { headers: { Authorization: `Bearer ${token}` } },
        );
        toast.success("Service added successfully");
      } else {
        const updated = [...existingServices];
        updated[editingServiceIndex] = service;
        await axios.patch(
          `https://backend.washta.com/api/seller/shop/${selectedShop._id}`,
          { services: updated, locationId: selectedLocation?._id },
          { headers: { Authorization: `Bearer ${token}` } },
        );
        toast.success("Service updated successfully");
      }
      setShowNewServiceEditor(false);
      setEditingServiceIndex(null);
      await fetchData();
    } catch (error) {
      console.log('asdasdasdasd',error)
      if (error.response?.status === 409) {
    const apiMessage = error.response?.data?.data || "";
    const serviceName = apiMessage.split(":").pop().trim();

    toast.warning(
      `The service "${serviceName}" already exists at the selected location. Please choose a different service or location.`
    );
  } else {
    toast.error("Failed to save the service. Please try again.");
  }
      console.error(error);
    }
  };

  const triggerBusinessImageInput = () => {
    if (businessImageInputRef.current) {
      businessImageInputRef.current.click();
    }
  };

  const handleBusinessImageUpload = async (event) => {
    const file = event.target.files?.[0];
    if (!file) return;

    if (file.size > 2 * 1024 * 1024) {
      toast.error("Image size must be less than 2MB");
      event.target.value = "";
      return;
    }

    const token = localStorage.getItem("accessToken");
    const uploadFormData = new FormData();
    uploadFormData.append("file", file);

    try {
      const uploadResponse = await axios.post(
        `${API_BASE_URL}/api/uploadFile`,
        uploadFormData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${token}`,
          },
        },
      );

      const uploadedImageUrl = uploadResponse?.data?.data?.path;
      if (!uploadedImageUrl) {
        toast.error("Image upload failed");
        return;
      }

      const profileResponse = await axios.get(
        `${API_BASE_URL}/api/seller/Profile`,
        {
          headers: { Authorization: `Bearer ${token}` },
        },
      );
      const currentBusiness = profileResponse?.data?.data?.business || {};

      const payload = {
        business: {
          ...currentBusiness,
          businessImage: uploadedImageUrl,
        },
      };

      await axios.patch(`${API_BASE_URL}/api/seller/Profile`, payload, {
        headers: { Authorization: `Bearer ${token}` },
      });

      setBusinessProfile((prev) => ({
        ...prev,
        businessImage: uploadedImageUrl,
      }));
      toast.success("Business image updated");
      await fetchData();
    } catch (error) {
      toast.error(
        error?.response?.data?.error ||
          error?.response?.data?.message ||
          "Image upload failed",
      );
    } finally {
      event.target.value = "";
    }
  };

  // ── Remove service — confirmation pehle ──
  const handleRemoveService = (service) => {
    openConfirm(
      "Remove Service",
      `Are you sure you want to remove "${service.serviceName}"?`,
      async () => {
        closeConfirm();
        if (!selectedShop) return;
        const token = localStorage.getItem("accessToken");
        const existingServices = Array.isArray(selectedLocation?.services)
          ? selectedLocation.services
          : [];
        const updated = existingServices.filter(
          (s) => s.serviceName !== service.serviceName,
        );
        try {
          await axios.patch(
            `https://backend.washta.com/api/seller/shop/${selectedShop._id}`,
            { services: updated, locationId: selectedLocation?._id },
            { headers: { Authorization: `Bearer ${token}` } },
          );
          toast.success("Service removed successfully");
          setEditingServiceIndex(null);
          await fetchData();
        } catch {
          toast.error("Failed to remove service");
        }
      },
    );
  };

  const services = Array.isArray(selectedLocation?.services)
    ? selectedLocation.services
    : [];

  return (
    <div className="mainDiv-all-sideBar ss-shell">
      <div className="div-sidebar">
        <Sidebar />
      </div>

      <div className="div-Dashbaord ss-content">
        {isLoading ? (
          <div>
            <div className="ss-account-section">
              <Skeleton variant="rounded" width={64} height={64} />
              <div style={{ flex: 1 }}>
                <Skeleton variant="text" width="35%" height={30} />
                <Skeleton variant="text" width="55%" height={22} />
                <Skeleton variant="text" width="70%" height={18} />
              </div>
            </div>
            <div className="ss-shop-strip">
              {[0, 1, 2, 3].map((i) => (
                <Skeleton key={i} variant="rounded" width={112} height={30} />
              ))}
              <Skeleton variant="rounded" width={96} height={30} />
            </div>
            <div className="ss-loading-grid">
              {[0, 1].map((i) => (
                <div key={i} className="ss-loading-card">
                  <Skeleton variant="text" width="30%" height={20} />
                  <Skeleton
                    variant="rectangular"
                    width="100%"
                    height={56}
                    sx={{ borderRadius: 2, mt: 1 }}
                  />
                  <Box sx={{ width: "100%", mt: 1 }}>
                    <Skeleton variant="text" width="75%" height={24} />
                    <Skeleton variant="text" width="55%" height={20} />
                    <Skeleton
                      variant="rectangular"
                      width="100%"
                      height={78}
                      sx={{ borderRadius: 2, mt: 1 }}
                    />
                  </Box>
                </div>
              ))}
            </div>
          </div>
        ) : (
          <>
            {/* Account Banner */}
            <div className="ss-account-section">
              <div
                className="ss-account-logo-upload"
                onClick={triggerBusinessImageInput}
                role="button"
                tabIndex={0}
                onKeyDown={(event) => {
                  if (event.key === "Enter" || event.key === " ") {
                    event.preventDefault();
                    triggerBusinessImageInput();
                  }
                }}
              >
                <input
                  ref={businessImageInputRef}
                  type="file"
                  accept=".png,.jpg,.jpeg"
                  style={{ display: "none" }}
                  onChange={handleBusinessImageUpload}
                />
                <div className="ss-account-logo-initials">
                  {businessBannerImage ? (
                    <img
                      src={businessBannerImage}
                      alt={businessBannerName}
                      style={{
                        width: "100%",
                        height: "100%",
                        objectFit: "cover",
                      }}
                    />
                  ) : (
                    getInitials(businessBannerName)
                  )}
                </div>
                <button type="button" className="ss-upload-overlay">
                  Change
                </button>
              </div>
              <div className="ss-account-info">
                <div className="ss-account-name">
                  {businessBannerName}
                </div>
                <div className="ss-account-desc">
                  Service provider account · {data.length} active locations
                </div>
                <div className="ss-account-logo-note">
                  ↑ This logo appears on all your service cards and booking
                  pages in the customer app
                </div>
                <div className="ss-account-logo-spec">
                  {businessProfile.description || "Square image · Min 200×200px · PNG or JPG · Max 2MB"}
                </div>
              </div>
            </div>

            {/* Shop strip */}
            <div className="ss-shop-strip">
              {data.map((shop, index) => (
                <div
                  key={shop._id}
                  className={`ss-shop-chip-wrap ${selectedShopId === shop._id ? "active" : ""}`}
                >
                  <button
                    type="button"
                    className={`ss-shop-chip ${selectedShopId === shop._id ? "active" : ""}`}
                    onClick={() => setSelectedShopId(shop._id)}
                  >
                    {getLocationLabel(shop, index)}
                  </button>
                  <button
                    type="button"
                    className="ss-shop-delete"
                    title={`Delete ${getLocationLabel(shop, index)}`}
                    onClick={(e) => {
                      e.stopPropagation();
                      handleDeleteShop(shop._id, getLocationLabel(shop, index));
                    }}
                  >
                    <MdDeleteOutline />
                  </button>
                </div>
              ))}
              <button
                type="button"
                className="ss-shop-add"
                onClick={togglePopup}
              >
                + Add location
              </button>
            </div>

            {selectedShop ? (
              <>
                <div className="ss-section-header">
                  <div className="ss-section-title">
                    Services at {getLocationLabel(selectedShop)}
                  </div>
                  <div className="ss-footer-actions">
                    <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                      <span style={{ fontSize: 12, color: selectedShop.isActive === false ? '#e53e3e' : '#38a169', fontWeight: 600 }}>
                        {selectedShop.isActive === false ? 'Inactive' : 'Active'}
                      </span>
                      <Toggle
                        checked={selectedShop.isActive !== false}
                        onChange={() => handleToggleShopActive(selectedShop)}
                      />
                    </div>
                    <button
                      className="ss-btn-secondary"
                      onClick={() => handleEditClick(selectedShop)}
                    >
                      <FiEdit2 /> Edit
                    </button>
                    <button
                      className="ss-btn-primary"
                      onClick={() => {
                        setShowNewServiceEditor(true);
                        setEditingServiceIndex(null);
                      }}
                    >
                      + Add service
                    </button>
                  </div>
                </div>

                <div
                  className="ss-account-logo-spec"
                  style={{ marginBottom: "12px" }}
                >
                  You can edit this location anytime: working hours, radius,
                  location pin and location-specific services.
                </div>

                <div>
                  {showNewServiceEditor && (
                    <ServiceEditor
                      service={createBlankService()}
                      onSave={(service) => handleSaveService(service, true)}
                      onRemove={() => setShowNewServiceEditor(false)}
                      catalogOptions={serviceCatalog}
                      isNew={true}
                    />
                  )}

                  {services.map((service, index) =>
                    editingServiceIndex === index ? (
                      <ServiceEditor
                        key={index}
                        service={service}
                        onSave={(s) => handleSaveService(s, false)}
                        onRemove={() => handleRemoveService(service)}
                        catalogOptions={serviceCatalog}
                        isNew={false}
                      />
                    ) : (
                      <div key={index} className="ss-service-card ss-readonly">
                        <div className="ss-svc-header">
                          <div className="ss-svc-name-block">
                            <div className="ss-field-label">
                              Service name (shown on app)
                            </div>
                            <div className="ss-readonly-input ss-bold">
                              {service.serviceName}
                            </div>
                          </div>
                          <div className="ss-svc-actions">
                            <span
                              className="ss-action-link"
                              onClick={() => setEditingServiceIndex(index)}
                            >
                              Edit
                            </span>
                            <span
                              className="ss-action-link ss-danger"
                              onClick={() => handleRemoveService(service)}
                            >
                              Remove
                            </span>
                          </div>
                        </div>
                        <div className="ss-svc-body">
                          <div className="ss-svc-top-row">
                            <div className="ss-svc-image-col">
                              <div className="ss-field-label">
                                Service card image
                              </div>
                              {service.heroImageUrl ? (
                                <div className="ss-upload-preview">
                                  <img
                                    src={service.heroImageUrl}
                                    alt={service.serviceName}
                                    style={{
                                      width: "100%",
                                      height: "100%",
                                      objectFit: "cover",
                                    }}
                                  />
                                </div>
                              ) : (
                                <div className="ss-upload-preview placeholder">
                                  🖼️
                                </div>
                              )}
                            </div>
                            <div className="ss-svc-details-col">
                              <div className="ss-field-label">
                                Car types supported
                              </div>
                              <div className="ss-car-types-row">
                                {service.supportedCarTypes &&
                                service.supportedCarTypes.length > 0 ? (
                                  service.supportedCarTypes.map((type) => (
                                    <span key={type} className="ss-car-chip on">
                                      <div className="ss-checkbox">✓</div>
                                      {type}
                                    </span>
                                  ))
                                ) : (
                                  <span>No car types selected</span>
                                )}
                              </div>
                              {service.customCarTypes &&
                                service.customCarTypes.length > 0 && (
                                  <div style={{ marginTop: "8px" }}>
                                    <div className="ss-field-label">
                                      Custom car types
                                    </div>
                                    <div className="ss-car-types-row">
                                      {service.customCarTypes.map((type) => (
                                        <span
                                          key={type}
                                          className="ss-car-chip on"
                                        >
                                          <div className="ss-checkbox">✓</div>
                                          {type}
                                        </span>
                                      ))}
                                    </div>
                                  </div>
                                )}
                            </div>
                          </div>
                          <div className="ss-divider"></div>
                          <div>
                            <div className="ss-field-label">
                              Service variants ({service.variants?.length || 0})
                            </div>
                            {service.variants &&
                              service.variants.map((v, i) => (
                                <div
                                  key={i}
                                  style={{
                                    fontSize: "12px",
                                    color: "#666",
                                    marginTop: "8px",
                                    padding: "8px",
                                    backgroundColor: "#f5f5f5",
                                    borderRadius: "6px",
                                  }}
                                >
                                  <strong>{v.variantName}</strong> -{" "}
                                  {v.variantType}
                                </div>
                              ))}
                          </div>
                        </div>
                      </div>
                    ),
                  )}

                  {services.length === 0 && !showNewServiceEditor && (
                    <div className="ss-empty-state">
                      <h3>No services yet</h3>
                      <p>
                        Add your first service to start building your shop
                        catalog.
                      </p>
                      <button
                        className="ss-btn-primary"
                        onClick={() => setShowNewServiceEditor(true)}
                      >
                        + Add service
                      </button>
                    </div>
                  )}
                </div>
              </>
            ) : null}
          </>
        )}

        {isPopupOpen && (
          <PopupSellar
            fetchData={fetchData}
            id={userid}
            Cross={togglePopup}
            editData={editData}
          />
        )}

        {/* Confirm Modal */}
        <ConfirmModal
          isOpen={confirmModal.isOpen}
          title={confirmModal.title}
          message={confirmModal.message}
          onConfirm={confirmModal.onConfirm}
          onCancel={closeConfirm}
        />

        <ToastContainer />
      </div>
    </div>
  );
};

export default SellarShop;